import { startAuditSyncManager, syncQueuedAudits } from "lib/@offline/queued-audits"
import {
    enqueueAudit,
    getAllQueuedAudits,
    removeQueuedAudit,
    updateQueuedAuditMetadata,
    clearAllQueuedAudits,
} from "lib/@offline/local-audit-queue"

startAuditSyncManager()

window.auditQueue = {
    getAllQueuedAudits,
    syncQueuedAudits,
    enqueueAudit,
    removeQueuedAudit,
    updateQueuedAuditMetadata,
    clearAllQueuedAudits,
}
